<div class="file-download-three-action-list-item">
    <div class="file-download-item file-download-marked">
      <span [hidden]="!displayMark" class="marked" (click)="onMarkClick(file)">&nbsp;</span>
        <core-file-name-download
            [file]="file"
        ></core-file-name-download>   
    </div>
    <div  class="file-download-group">
        <div *ngIf="bubble" class="bubble">
            <span (click)="onBubbleClick(file)" [innerHTML]="bubbleNumber">{{ bubbleNumber }}</span>
        </div>
        <div *ngIf="actionOneText !=''" class="action {{actionOneStyle}}">
            <span ><em (click)="onActionOneClick(file)" [innerHTML]="actionOneText">{{ actionOneText }}</em></span>
        </div>
        <div *ngIf="actionTwoText !=''" class="action {{actionTwoStyle}}">
            <span ><em (click)="onActionTwoClick(file)" [innerHTML]="actionTwoText">{{ actionTwoText }}</em></span>
        </div>
        <div *ngIf="actionThreeText !=''" class="action {{actionThreeStyle}}">
            <span ><em (click)="onActionThreeClick(file)" [innerHTML]="actionThreeText">{{ actionThreeText }}</em></span>
        </div>
        <div class="download-extension">
            <span [innerHTML]="file.extension">{{file.extension}}</span>
        </div>
    </div>
</div>
